import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import ClientsFilter from "../components/ClientsFilter";
import ClientsList from "../components/ClientsList";
import Preloader from "../components/Preloader";
import { updateCallsDates, loadClients, exportCards } from "../actions/clientsActions";

class Clients extends Component {
  filter = {};

  componentWillMount() {
    if (window.location.hash.startsWith("#p_")) {
      let page = window.location.hash.substr(3);
      page = parseInt(page, 10);
      this.props.loadClients(
        { type: this.props.type },
        { size: 70, page: page }
      );
    } else {
      this.props.loadClients({ type: this.props.type });
    }
  }

  handleFilterChange = (filter, paginator) => {
    this.props.loadClients(filter, paginator);
    this.filter = filter;
    console.log("DATA FILTER FORM CLIENTS", filter);
  };

  exportDataAccordingFilter = (filter, paginator) => {
      this.props.exportCards(filter, paginator);
  };

  handlePaginatorChange = ({ selected }) => {
    this.props.loadClients(
      { ...this.filter, type: this.props.type },
      { ...this.props.paginator, page: selected + 1 }
    );
  };

  getTypeNumber = () => {
    switch (this.props.type) {
      case "suplier":
        return 1;
      case "client":
        return 2;
      case "elevator":
        return 3;
      default:
        return null;
    }
  };

  render() {
    const {
      updateCallsDates: updateDates,
      clients,
      selectsData,
      loading,
      type,
      paginator,
      downloadingExportUrl
    } = this.props;

    return (
      <div className="container">
        <div className="well mr-bottom-40">
          {/*Форма фильтрации на страницах*/}
          {console.log("SELECTED DATA", selectsData)}
          <ClientsFilter
            selectsData={selectsData}
            downloadingExportUrl={downloadingExportUrl}
            onSubmit={this.handleFilterChange}
            onExportData={this.exportDataAccordingFilter}
            type={type}
            paginator={paginator}
          />
        </div>
        {loading ? (
          <Preloader />
        ) : (
          <ClientsList
            updateCallsDates={updateDates}
            list={clients}
            paginator={paginator}
            filter={this.filter}
            onPaginatorChange={this.handlePaginatorChange}
            type={this.getTypeNumber()}
          />
        )}
      </div>
    );
  }
}

Clients.propTypes = {
  updateCallsDates: PropTypes.func.isRequired,
  clients: PropTypes.array,
  selectsData: PropTypes.object,
  loading: PropTypes.bool,
  loadClients: PropTypes.func.isRequired,
  type: PropTypes.string,
  paginator: PropTypes.object,
  downloadingExportUrl: PropTypes.string,
  exportCards: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  clients: state.clients.list,
  downloadingExportUrl: state.clients.downloadingExportCardsUrl,
  paginator: state.clients.paginator,
  selectsData: state.webInterface.initData,
  loading:
    state.webInterface.loading ||
    state.clients.loading ||
    !state.webInterface.initData
});

const mapDispatchToProps = dispatch => ({
  updateCallsDates: (to_time, client) => dispatch(updateCallsDates(to_time, client)),
  loadClients: (filter, pager) => dispatch(loadClients(filter, pager)),
  exportCards: (filter, pager) => dispatch(exportCards(filter, pager))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Clients);



// WEBPACK FOOTER //
// ./containers/Clients.js